import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chess-tournament-chandrapur',
  templateUrl: './chess-tournament-chandrapur.component.html',
  styleUrls: ['./chess-tournament-chandrapur.component.scss']
})
export class ChessTournamentChandrapurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
